// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"../../../styles/colors.css\"","netsurfDarkBlue":"#151F41","netsurfPurple":"#6C4EE2","netsurfBorderColor":"rgba(21, 31, 65, 0.16)"};